export const paymentTypes = {
  MINIMUM_DUE: 'Minimum Due',
  PAYMENT_DUE: 'Payment Due',
  MONTHLY_PAYMENT_DUE: 'Monthly Payment Due',
  PLAN_ADJUSTED_BALANCE: 'Adjusted Balance',
  PLAN_BALANCE: 'Outstanding Balance',
  NON_DEFERRED_ADJUSTED_BALANCE: 'Standard Balance',
  CURRENT_BALANCE_ADJUSTED: 'Remaining Statement Balance',
  PAYMENT_DUE_ADJUSTED: 'Remaining Statement Balance',
  CURRENT_BALANCE: 'Statement Balance',
  MONTHLY_PLAN_BALANCE: 'Monthly Payment',
  EARLY_PAY: 'Early Pay',
  DEFER_PAY: 'Defer Pay',
  OUTSTANDING_BALANCE: 'Outstanding Balance',
  FULL_BALANCE: 'Total Balance',
  PERCENTAGE_AMOUNT: 'Percentage Amount',
  FIXED_AMOUNT: 'Another Amount',
};

export const autoPayFrequencyType = {
  BI_WEEKLY: 'Bi Weekly',
  DAILY: 'Daily',
  WEEKLY: 'Weekly',
  CYCLE_CUT: 'Monthly',
  MONTHLY: 'Monthly',
  IMMEDIATE: 'Monthly',
  EXPOSURE: 'Threshold',
};

export const autoPayOptions = {
  CURRENT_BALANCE: 'Statement Balance',
  CURRENT_BALANCE_ADJUSTED: 'Adjusted Balance',
  DEFER_PAY: 'Defer Pay',
  FULL_BALANCE: 'Statement Balance',
  MINIMUM_DUE: 'Minimum Due',
  MONTHLY_PLAN_BALANCE: 'Monthly Payment',
  NON_DEFERRED_ADJUSTED_BALANCE: 'Standard Balance',
  OUTSTANDING_BALANCE: 'Total Balance',
  PAYMENT_DUE: 'Payment Due',
  PAYMENT_DUE_ADJUSTED: 'Remaining Statement Balance',
  PLAN_ADJUSTED_BALANCE: 'Adjusted Balance',
};

export const eventNames = [
  'START_SESSION',
  'WELCOME_LOAD_OK',
  'WELCOME_OK',
  'PAYBILL_OK',
  'PAYBILL_BACK',
  'REVIEW_SUBMIT_PAYMENT',
  'REVIEW_BACK',
  'FINISH_LOAD_OK',
  'FINISH_OK',
  'FINISH_BALANCE',
  'FINISH_CONTINUE_PHONE',
  'EXPERIENCE_SUBMIT',
  'HAMBURGER_OPEN',
  'HAMBURGER_CLOSE',
  'HAMBURGER_CONTINUE_PHONE',
  'HAMBURGER_CCP',
  'ERROR_APP',
  'FINISH_RATE_EXPERIENCE',
];
